export default function RcmpArrowDownThin(props) {
  return (
    <svg width={props.width || "12"} height={props.height || "7"} viewBox="0 0 12 7" fill={props.fill || "#ACB4BA"} xmlns="http://www.w3.org/2000/svg">
      <path d="M11.1508 1.35392L6.41005 5.89665C6.29585 6.007 6.1477 6.06179 6.00032 6.06179C5.85293 6.06179 5.70481 6.007 5.59061 5.89665L0.849908 1.35392C0.613018 1.12795 0.60529 0.752932 0.832155 0.516833C1.05746 0.279178 1.43401 0.27145 1.66934 0.49908L6.00032 4.6484L10.3313 0.49908C10.5659 0.27145 10.9432 0.279178 11.1685 0.516833C11.3953 0.752932 11.3876 1.12795 11.1508 1.35392Z" />
    </svg>
  )
}
